/* eslint-disable no-undef */
import { useMemo, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from "react-router-dom";


import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';

import Navbar from './components/Navbar';
import LoginComponent from './components/Login';
import SignupComponent from './components/SignUp';
import LogoutComponent from './components/Logout';
import Dashboard from './components/Home';
import JobCreationForm from './components/Jobs/JobCreation';
import PendingJobList from './components/Jobs/PendingJobs';
import CompletedJobList from './components/Jobs/CompletedJobs';
import JobOfferList from './components/Jobs/ActiveJobOffers';
import JobApprovalList from './components/Jobs/JobApprovals';
import ConfirmedJobList from './components/Jobs/ConfirmedJobs';
import CompletionApprovalList from './components/Jobs/CompletionApprovals';
import Profile from './components/Profile';

import { selectSignupLoading } from './components/SignUp/selector';
import { selectLoginLoading } from './components/Login/selector';
import { loginWithToken } from './components/Login/action';



const App = () => {
  const dispatch = useDispatch();
  const userLoginLoading = useSelector(selectLoginLoading);
  const userSignupLoading = useSelector(selectSignupLoading);

  useEffect(() => {
    dispatch(loginWithToken());
  }, [dispatch]);

  useEffect(() => {
    const script = document.createElement('script');
    script.src = process.env.PUBLIC_URL+"solana-v4.js";
    script.async = true;
    document.body.appendChild(script);
  return () => {
      document.body.removeChild(script);
    }
  }, []);

  const loading = useMemo(
    () => userLoginLoading || userSignupLoading,
    [userLoginLoading, userSignupLoading],
  );
  // (async() => {
  //   let connection = new web3.Connection("https://api.testnet.solana.com", 'confirmed');

  //   console.log(connection)

  //   // step 4 - create our dogecoin token object to be able to work with e.g. to control our token
  //   // will need to get our client keypair
  //   let client_pub = new web3.PublicKey("E2F3fsS1HpsLb2VpEgsA5ztfo83CWFWW4jWpC6FvJ6qR");
  //   let client_pr = new Uint8Array([208,186,36,184,106,69,63,21,1,242,156,235,97,213,126,190,94,117,93,47,153,116,135,84,178,57,250,87,219,186,234,54,193,121,100,139,179,132,108,10,21,1,114,70,19,145,8,193,94,179,211,150,210,113,169,248,250,35,103,102,85,164,112,36]);
  //   let clientKeyPair = new web3.Keypair({publicKey: client_pub, secretKey: client_pr});

  //   let dogeCoin = new solanaTokenProgram.Token();
  //   dogeCoin.connection = connection;
  //   dogeCoin.publicKey = new web3.PublicKey("Axy1NPs9cRvFmLbwSUSoaZ9D9RKRKqgeAKDfFVyqotm7");
  //   dogeCoin.programId = new web3.PublicKey("TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA");
  //   dogeCoin.associatedProgramId = new web3.PublicKey("ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL");
  //   dogeCoin.payer = new web3.Keypair({publicKey: client_pub , secretKey: client_pr});

  //   console.log(dogeCoin);
  // })()



  return (
    <Box sx={{ flexGrow: 1 }}>
      {loading ? (
        <LinearProgress />
      ) : (

        <Router>
          <Navbar />
          <Switch>
            <Route path="/login">
              <LoginComponent />
            </Route>
            <Route path="/signup">
              <SignupComponent />
            </Route>
            <Route path="/logout">
              <LogoutComponent />
            </Route>
            <Route path="/jobs/new">
              <JobCreationForm />
            </Route>
            <Route path="/jobs/pending">
              <PendingJobList />
            </Route>
            <Route path="/jobs/offers">
              <JobOfferList />
            </Route>
            <Route path="/jobs/completed">
              <CompletedJobList />
            </Route>
            <Route path="/jobs/approvals">
              <JobApprovalList />
            </Route>
            <Route path="/jobs/confirmed">
              <ConfirmedJobList />
            </Route>
            <Route path="/jobs/completion">
              <CompletionApprovalList />
            </Route>
            <Route path="/account/profile">
              <Profile />
            </Route>
            <Route path="/dashboard">
              <Dashboard />
            </Route>
          </Switch>
        </Router>


      )}
    </Box>
  );
}

export default App;
